import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class WeatherService {
  public baseUrl = "http://130.61.175.227/";

  constructor(private httpClient: HttpClient) { }

  public getWeather(): Observable<any> {
    return this.httpClient.get(this.baseUrl);
  }
}
